import {DateTime} from 'luxon';

type FormatAcademicYearOptions = {
    startDate?: string
    endDate?: string
}

export const formatAcademicYearPeriod = ({
    startDate,
    endDate
}: FormatAcademicYearOptions): string => {
    if (!startDate || !endDate) {
        return 'No Academic Year found';
    }

    const startDateText = DateTime.fromISO(startDate, {zone: 'utc'}).toFormat('dd LLL yyyy');
    const endDateText = DateTime.fromISO(endDate, {zone: 'utc'}).toFormat('dd LLL yyyy');

    return `${startDateText} - ${endDateText}`;
};

export const formatAcademicYearsPeriod = ({
    startDate,
    endDate
}: FormatAcademicYearOptions): string => {
    if (!startDate || !endDate) {
        return 'No Academic Year found';
    }

    const startDateText = DateTime.fromISO(startDate, {zone: 'utc'}).toFormat('yyyy');
    const endDateText = DateTime.fromISO(endDate, {zone: 'utc'}).toFormat('yyyy');

    return `${startDateText} - ${endDateText}`;
};
